<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="topic.industry.id"
          :items="industries"
          item-text="name"
          item-value="id"
          label="Industry"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="topic.name"
          label="Name"
          hide-details="auto"
          maxlength="100"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="topic.urlSegment"
          label="Url Segment"
          hide-details="auto"
          maxlength="100"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="topic.designNotes"
          label="Design Notes"
          hide-details
          outlined
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="topic.disableInCatalog"
          label="Disable in Catalog?"
          hide-details
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AddDesignGroup',

  data() {
    return {
      topic: {},
      valid: false,
      saving: false
    };
  },
  computed: {
    ...mapGetters({
      industries: 'lookup/industries'
    })
  },
  mounted() {
    this.topic = { industry: {} };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('topics/create', this.topic)
        .then(() => {
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE);
          this.$root.$snackbarSuccess('Topic created');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
